<template>
  <div class="projectBox">
    <div class="projectBox-top">
      <div class="projectBox-top-left">工作经历</div>

      <div class="projectBox-top-right">
        <span v-for="(item, index) in companyList" :key="index">
          <el-tooltip
            class="item"
            effect="dark"
            :content="item.fullName"
            placement="bottom"
          >
            <span
              :class="chooseFlag === index ? 'choose-it' : ''"
              @click="chooseIt(item, index)"
            >
              {{ item.showName }}
            </span>
          </el-tooltip>
        </span>
      </div>
    </div>

    <div class="slide active">
      <tianLing ref="tianLing" />
    </div>

    <div class="slide">
      <qiYun ref="qiYun" />
    </div>
  </div>
</template>

<script>
import qiYun from "@/views/homePage/projectBoxUnit/qiYun";
import tianLing from "@/views/homePage/projectBoxUnit/tianLing";
import { companyList, companyListEncryption } from "@/api/apifoxInterface";
export default {
  name: "projectBox",
  components: { qiYun, tianLing },
  props: {},
  computed: {
    permission() {
      return this.$store.state.auth.permission;
    },
  },
  watch: {
    permission(newVal) {
      if (newVal.id === 3) {
        this.getCompanyList();
      }
    },
  },
  data() {
    return {
      chooseFlag: 0,
      companyList: [],
      helpCompanyList: require("@/lib/json/apifox/companyList.json"),
      helpCompanyListEncryption: require("@/lib/json/apifox/companyListEncryption.json"),
    };
  },
  methods: {
    chooseIt(item, index) {
      this.chooseFlag = index;
      // fullpage_api.moveSlideRight(); // 向右移动
      this.$parent.moveTo("index?page=2", index); // 移动到指定位置
    },

    /**
     * @Event 方法
     * @description: 自动滚动
     * */
    autoPlay() {
      this.time = setInterval(() => {
        this.$refs.page.api.moveSlideRight(); // 向右滚动
      }, 15000);
    },

    /**
     * @Event 方法
     * @description: 点击左下角的小圆点，同时更新右上角选中状态
     * */
    updateChooseFlag(index) {
      this.chooseFlag = index;
    },

    async getCompanyList() {
      const getCompanyData = async () => {
        const res = await (this.permission.id === 3
          ? companyList()
          : companyListEncryption());
        if (res.data.code === 200) {
          return res.data.data;
        } else if (res.data.code === 504) {
          return this.permission.id === 3
            ? this.helpCompanyList.data
            : this.helpCompanyListEncryption.data;
        }
        throw new Error(`Failed with code: ${res.data.code}`);
      };

      try {
        this.companyList = await getCompanyData();
      } catch (error) {
        console.error("An error occurred:", error.message);
      }
    },

    initCanvasRibbon() {
      new Ribbons({
        colorSaturation: "80%",
        colorBrightness: "50%",
        colorAlpha: 0.6,
        colorCycleSpeed: 12,
        verticalPosition: "center",
        horizontalSpeed: 1,
        ribbonCount: 3,
        strokeSize: 0,
        parallaxAmount: -0.5,
        animateSections: true,
      });
    },
  },
  created() {
    this.initCanvasRibbon();
    this.getCompanyList();
  },
  mounted() {},
  destroyed() {
    // clearInterval(this.time)
  },
};
</script>

<style lang="scss" scoped>
.projectBox {
  padding: 20px;
  /* 加载背景图 */
  /*background-image: url("/public/img/indexBg/doodles.jpeg");*/
  /* 背景图垂直、水平均居中 */
  /*background-position: center center;*/
  /* 背景图不平铺 */
  /*background-repeat: no-repeat;*/
  /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */
  /*background-attachment: fixed;*/
  /* 让背景图基于容器大小伸缩 */
  /*background-size: cover;*/
  /* 设置背景颜色，背景图加载过程中会显示背景色 */
  /*background-color: #eabae2;*/

  &-top {
    height: 50px;
    display: flex;
    justify-content: space-between;
    line-height: 50px;

    &-left {
      font-size: 20px;
      font-weight: bold;
    }

    &-right {
      font-size: 14px;
      color: rgb(51, 51, 51);
    }

    &-right :first-child {
      margin-right: 10px;
    }

    &-right span:hover {
      color: #000;
      font-weight: bold;
      cursor: pointer;
    }
  }
}

/*.projectBox::before {*/
/*  content: "";*/
/*  position: absolute;*/
/*  top: 0;*/
/*  left: 0;*/
/*  right: 0;*/
/*  bottom: 0;*/
/*  background: rgba(0, 0, 0, 0.2);*/
/*  z-index: 1;*/
/*}*/

.choose-it {
  color: #000;
  font-weight: bold;
}

::v-deep .el-descriptions__header {
  display: block !important;
  text-align: center;
}
</style>
